import * as React from "react";

export const NoLongTermIcon = ({
  width = 48,
  height = 48,
  className,
  title = "No Long Term",
  ...rest
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
    {...rest}>
    <title>{title}</title>
    <path
      fill="#00226A"
      stroke="#fff"
      strokeWidth={0.5}
      d="M21.323 13.584h26.612c.35 0 .698.176.891.475.2.31.244.686.11 1.04l-10.55 25.45-2.363 5.693-8.056 19.494c-.18.4-.578.68-1.004.68h-5.64c-.61 0-1.093-.503-1.093-1.093V14.677l.006-.114c.055-.558.512-.98 1.087-.98Zm1.093 50.647h3.8l.064-.155 6.955-16.81.144-.346h-3.973a1.08 1.08 0 0 1-1.092-1.093c0-.614.479-1.093 1.092-1.093h4.867l.064-.154 1.235-3.008.142-.345h-6.308a1.08 1.08 0 0 1-1.092-1.092 1.08 1.08 0 0 1 1.092-1.093h7.23l.064-.154 9.452-22.773.144-.346h-23.88v48.462Z"
    />
    <path
      fill="#5DCDFF"
      stroke="#fff"
      strokeWidth={0.5}
      d="M53.736 13.584h4.941c.59 0 1.093.482 1.093 1.093v50.646c0 .587-.506 1.093-1.093 1.093H32.763c-.37 0-.721-.197-.918-.503l-.005-.007a1.094 1.094 0 0 1-.108-.997l8.083-19.523.003-.008.003-.009a.336.336 0 0 1 .031-.058.851.851 0 0 0 .068-.141h.002l2.256-5.477 10.526-25.43c.176-.416.568-.68 1.032-.68Zm.655 2.34-9.426 22.772-.142.346h6.012c.587 0 1.093.506 1.093 1.093 0 .586-.506 1.092-1.093 1.092h-6.934l-.064.155-1.235 3.008-.142.344h8.375c.587 0 1.093.506 1.093 1.093s-.506 1.093-1.093 1.093H41.54l-.065.154-6.955 16.812-.142.345h23.207V15.77h-3.128l-.065.155Z"
    />
    <path
      fill="#00226A"
      stroke="#fff"
      strokeWidth={0.5}
      d="M29.352 33.389h5.801c.6 0 1.093.492 1.093 1.092 0 .6-.492 1.093-1.093 1.093h-5.8c-.6 0-1.093-.492-1.093-1.093 0-.6.492-1.092 1.092-1.092Z"
    />
  </svg>
);
